"use strict";

require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.components = void 0;
require("core-js/modules/es.array.reduce.js");
var _paulCorePackage = require("paul-core-package");
var types = _interopRequireWildcard(require("../types/components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Types = require("../../Types");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const {
  ComponentTypes
} = _paulCorePackage.constants;
const initialState = {
  buildings: [],
  structure: {},
  activeBuilding: null,
  activePwhC: null,
  activeStructure: {
    total: {
      [ComponentTypes.HtgSys]: {},
      [ComponentTypes.HtgSub]: {},
      [ComponentTypes.HtgHx]: {},
      [ComponentTypes.HtgPipe]: {},
      [ComponentTypes.HtgCc]: {},
      [ComponentTypes.PwhSupply]: {},
      [ComponentTypes.PwcPoe]: {},
      [ComponentTypes.PwhC]: {},
      [ComponentTypes.PwhPipe]: {}
    }
  },
  devices: {
    byId: {} // {[id]: device, ...}
  },

  hasData: false,
  errors: []
};
const components = function components() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let {
    type,
    payload
  } = arguments.length > 1 ? arguments[1] : undefined;
  const {
    payload: listenPayload = null,
    result: listenResult = null
  } = payload || {};
  switch (type) {
    case types.SET_INITIAL_DEVICE_DATA:
    case _paulCorePackage.listenerTypes.GET_DEVICES_LISTENER:
      {
        var _Object$keys, _listenResult$devices;
        const newStructure = (_Object$keys = Object.keys(listenResult.structure || {})) === null || _Object$keys === void 0 ? void 0 : _Object$keys.reduce((accList, componentType) => {
          if (componentType === ComponentTypes.PwhPipe || componentType === ComponentTypes.HtgPipe) return accList;
          const listComponentsByType = Object.values(listenResult.structure[componentType]).reduce((accC, component) => {
            const equipmentName = listenResult.equipmentNames[component.id];
            return _objectSpread(_objectSpread({}, accC), {}, {
              [component.id]: _objectSpread(_objectSpread({}, component), {}, {
                name: equipmentName
              })
            });
          }, {});
          return _objectSpread(_objectSpread({}, accList), {}, {
            [componentType]: listComponentsByType
          });
        }, {});
        // const BuildingIdList = Object.values(newStructure.HtgSys)?.reduce((acc, sys) => {
        //                 if (acc.find(b => JSON.stringify(b) === JSON.stringify(sys.building || [])))
        //                     return acc
        //                 return [...acc, sys.building || []]
        //             }, [])
        // const defActiveBuildingId = BuildingIdList[0] ? BuildingIdList[0][0] || null : null;
        // const structure = functions.getStatusDevice({structure: newStructure, buildingId: defActiveBuildingId});

        // console.log('MDM',
        //     listenPayload,
        //     'newStructure',
        //     newStructure,
        //     '\n ================== \ndeviceById',
        //     listenResult?.devices?.byId)

        return _objectSpread(_objectSpread({}, state), {}, {
          buildings: listenResult.allBuildings,
          activeStructure: _objectSpread(_objectSpread({}, state.activeStructure), {}, {
            total: newStructure
          }),
          activeBuilding: null,
          activePwhC: null,
          allPwhCByHtgSys: newStructure.PwhC,
          structure: newStructure,
          devices: _objectSpread(_objectSpread({}, state.devices), {}, {
            byId: (listenResult === null || listenResult === void 0 ? void 0 : (_listenResult$devices = listenResult.devices) === null || _listenResult$devices === void 0 ? void 0 : _listenResult$devices.byId) || {}
          }),
          hasData: true
        });
      }
    case _paulCorePackage.listenerTypes.GET_VALUES_LISTENER:
      {
        var _listenResult$devices2;
        if (_paulCorePackage.functions.isEmpty(listenPayload)) return state;
        return _objectSpread(_objectSpread({}, state), {}, {
          devices: _objectSpread(_objectSpread({}, state.devices), {}, {
            byId: (_listenResult$devices2 = listenResult.devices) === null || _listenResult$devices2 === void 0 ? void 0 : _listenResult$devices2.byId
          })
        });
      }
    case _paulCorePackage.listenerTypes.GET_VALUE_LISTENER:
      {
        const device = state.devices.byId[listenPayload.thingPDIDDevice];
        if (!device) return state;
        return _objectSpread(_objectSpread({}, state), {}, {
          devices: _objectSpread(_objectSpread({}, state.devices), {}, {
            byId: listenResult.devices.byId
          })
        });
      }
    case types.RESET_STRUCTURE:
      {
        return initialState;
      }
    default:
      return state;
  }
};

/** @todo fit all UNKNOWN_TYPE types */
exports.components = components;
const UNKNOWN_TYPE = _propTypes.default.any;
components.propTypes = [_propTypes.default.shape({
  buildings: _propTypes.default.arrayOf(UNKNOWN_TYPE).isRequired,
  structure: _Types.structureType,
  activeBuilding: UNKNOWN_TYPE,
  activePwhC: UNKNOWN_TYPE,
  activeStructure: _propTypes.default.shape({
    total: _Types.structureType.isRequired
  }).isRequired,
  devices: _propTypes.default.shape({
    byId: _propTypes.default.shape({
      [_Types.equipmentIdType]: _Types.deviceType
    }).isRequired
  }).isRequired,
  hasData: _propTypes.default.bool.isRequired,
  errors: _propTypes.default.arrayOf(_propTypes.default.shape({
    method: _propTypes.default.string
  })).isRequired
}), _propTypes.default.shape({
  type: _propTypes.default.string.isRequired,
  payload: _propTypes.default.shape({})
})];